import { gql } from '@apollo/client';

export const GET_VALUESET = gql`
  query GetValueset(
    $url: String!
    $page: Int!
    $perPage: Int!
    $language: String!
    $filter: GqlValuesetConceptsFilter!
  ) {
    valueset {
      valuesetConcepts(
        url: $url
        page: $page
        perPage: $perPage
        language: $language
        filter: $filter
      ) {
        pageInfo {
          totalItems
          page
          perPage
          totalPages
          hasNextPage
          hasPreviousPage
        }
        items {
          system
          version
          code
          display
        }
      }
    }
  }
`;
